import * as yup from 'yup';
import { prettyQuote } from '../../types/quotes/newQuotes/IQuote';
import * as _ from 'lodash';

yup.setLocale({
  mixed: {
    required: (val) => `${val.path ? _.get(prettyQuote, val.path, val.path) : val.path} is Required`,
  },
  string: {
    min: (val) => `Enter ${val.min} digits`,
    email: () => `Enter a valid email`,
  },
});

export default yup;
